const primeiroNome = /([A-zÀ-ú]+)/;

export default function extrairPrimeiroNome(nome) {
    if (!nome || nome.trim() === "")
        return undefined

    return nome?.match(primeiroNome)[0]
}